class PuffNameAddon extends HTMLElement {
  connectedCallback() {
    this.hidden = false;
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.input = this.querySelector('input[type="text"]');
    this.fields = this.querySelector('.puff-name-addon__fields');
    this.checkbox.addEventListener('change', this.sync);
    this.sync();
  }
  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.sync);
  }
  sync = () => {
    const enabled = this.checkbox.checked;
    this.fields.hidden = !enabled;
    this.input.disabled = !enabled;
    this.input.required = enabled;
    this.checkbox.setAttribute('aria-expanded', String(enabled));
    if (!enabled) this.input.value = '';
  };
  selection() {
    if (!this.checkbox.checked) return null;
    this.input.value = this.input.value.trim();
    if (!this.input.reportValidity()) return false;
    return { id: this.dataset.variantId, name: this.input.value };
  }
}
if (!customElements.get('puff-name-addon')) customElements.define('puff-name-addon', PuffNameAddon);
